import * as React from 'react';
import {observer} from 'mobx-react';
import {CreditCard} from './credit-card';
import {content, horizontal, horizontallySpaced, vertical, verticallySpaced, wrap} from 'csstips';
import {classes, style} from 'typestyle';
import {percent, px} from 'csx';
import {CreditCardAdd} from './credit-card-add';
import {mediaMobileOnly, mediaTablet} from '../theme/media';
import {CardSchema} from '../types/schema';

export interface CreditCardsModel {
  cards: Array<CardSchema>;
  selectedCard?: string;
  showAddCard?: boolean;
}

export interface CreditCardsProps {
  model: CreditCardsModel;
  onAddCard?(): void;
  onEditCard?(identity: string): void;
  onRemoveCard?(identity: string): void;
  onSelectCard?(identity: string): void;
  i18n?: {
    add: string;
  }
}

const DEFAULT_I18N = {
  add: 'Add payment method'
};

export const CreditCards = observer<CreditCardsProps>(
  ({ model, onAddCard, onEditCard, onRemoveCard, onSelectCard, i18n = DEFAULT_I18N }) => (
    <div className={styles.container}>
      {model.cards.map((card, index) => (
        <CreditCard
          className={classes(styles.item, onSelectCard && styles.itemSelectable)}
          onEditCard={onEditCard}
          onRemoveCard={onRemoveCard}
          onSelectCard={onSelectCard}
          selected={model.selectedCard === card.identity}
          model={card}
          showAddress={true}
          key={index}
        />
      ))}
      {onAddCard && (
        <CreditCardAdd
          className={styles.item}
          selected={model.showAddCard}
          onAddCard={onAddCard}
        />
      )}
    </div>
  )
);

const styles = {
  container: style(
    {
      ...wrap,
      ...content,
    },
    mediaTablet({
      ...horizontal,
      ...horizontallySpaced(20),
    }),
    mediaMobileOnly({
      ...vertical,
      ...verticallySpaced(20),
    })
  ),
  item: style(
    {
      ...content
    },
    mediaTablet({
      width: percent(50),
      maxWidth: px(320),
      margin: '0 0 20px 0'
    }),
    mediaMobileOnly({
      width: percent(100),
      maxWidth: px(420),
    })
  ),
  itemSelectable: style({
    cursor: 'pointer'
  })
};